// extracted by mini-css-extract-plugin
module.exports = {"frameContainer":"IFrameWrapper-module--frameContainer--2hxBM"};